const mode = process.env.REACT_APP_ENV_MODE || process.env.NODE_ENV

export enum Env {
  Development = 'development',
  Test = 'test',
  Production = 'production',
  Release = 'release',
  PT = 'pt',
  Baker = 'baker',
}

export const EnvBasedStyles = {
  [Env.Development]: {
    label: 'dev',
    color: '#6f9c3d',
    logoColor: '#fff',
  },
  [Env.Test]: {
    label: 'test',
    color: '#ff8829',
    logoColor: '#fff',
  },
  [Env.Release]: {
    label: 'release',
    color: '#3b82f6',
    logoColor: '#fff',
  },
  [Env.PT]: {
    label: 'PT',
    color: '#bb3bf6ff',
    logoColor: '#fff',
  },
  [Env.Baker]: {
    label: 'Baker',
    color: '#bb3bf6ff',
    logoColor: '#fff',
  },
  [Env.Production]: {
    label: undefined,
    color: undefined,
    logoColor: undefined,
  },
  default: {
    label: 'default',
    color: undefined,
    logoColor: undefined,
  },
}

export const isDev = () => mode === Env.Development || mode === 'dev'
export const isTest = () => mode === Env.Test
export const isRelease = () => mode === Env.Release
export const isPT = () => mode === Env.PT
export const isProd = () => mode === Env.Production
export const getMode = () => mode || 'default'
